import { render } from "./guid-use-existing.vue?vue&type=template&id=4793944a"
const script = {}

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/create-catalog/guid-use-existing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4793944a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4793944a', __exports__)) {
    console.log('reload')
    api.reload('4793944a', __exports__)
  }
  
  module.hot.accept("./guid-use-existing.vue?vue&type=template&id=4793944a", () => {
    console.log('re-render')
    api.rerender('4793944a', render)
  })

}


export default __exports__